<!-- 地图 -->
<style lang="stylus" scoped>
.detail {
  height: 648px;
  width: 420px;
  background: url('../../../../static/img/recordInformation/5.png') no-repeat;
  background-position: 0px -96px;
  color: #fff;
  padding: 15px 22px 0;
  box-sizing: border-box;

  .tit {
    font-size: 28px;
    text-align: center;
  }

  .list {
    margin-top: 20px;

    .list-item {
      display: flex;
      line-height: 60px;
      flex-wrap: wrap;

      img {
        margin-right: 30px;
        width: 24px;
        height: 20px;
        margin-top: 24px;
      }

      .img1 {
        width: 20px;
        height: 24px;
      }

      .img2 {
        height: 24px;
      }

      .img3 {
        width: 22px;
        height: 24px;
      }
    }

    .msg {
      width: 320px;
      font-size: 20px;
      border-bottom: 1px solid #0092EE;
    }

    .list-item1 {
      .msg {
        border-bottom: none;
      }

      .trace-pro {
        margin-left: 54px;

        img {
          width: 100px;
          height: 90px;
          margin-right: 4px;
        }
      }
    }
  }
}
</style>

<template>
  <div class="detail">
    <p class="tit">企业信息介绍</p>
    <div class="list">
      <div class="list-item">
        <img src="../../../../static/img/recordInformation/11.png" alt>
        <div class="msg">{{positionItem.name}}</div>
      </div>
      <div class="list-item">
        <img class="img1" src="../../../../static/img/recordInformation/12.png" alt>
        <div class="msg">{{positionItem.address}}</div>
      </div>
      <div class="list-item">
        <img class="img2" src="../../../../static/img/recordInformation/6.png" alt>
        <div class="msg">{{positionItem.phone}}</div>
      </div>
      <div class="list-item list-item1">
        <img class="img3" src="../../../../static/img/recordInformation/7.png" alt>
        <div class="msg">可追溯商品 12 种</div>
        <div class="trace-pro">
          <img src="../../../../static/img/recordInformation/3.png" alt>
          <img src="../../../../static/img/recordInformation/3.png" alt>
          <img src="../../../../static/img/recordInformation/3.png" alt>
        </div>
      </div>
      <div class="list-item">
        <img class="img2" src="../../../../static/img/recordInformation/10.png" alt>
        <div class="msg">溯源基地 2 个</div>
      </div>
      <div class="list-item">
        <img src="../../../../static/img/recordInformation/8.png" alt>
        <div class="msg">气象设备2台</div>
      </div>
      <div class="list-item">
        <img class="img1" src="../../../../static/img/recordInformation/9.png" alt>
        <div class="msg">监控设备14台</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    positionTimes: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      detailList: [
        { name: '广西田阳天穗农产品贸易有限公司', address: '广西省百色市', phone: '88383928' },
        { name: '广西百色盛泰和农业有限公司', address: '广西省百色市', phone: '88383928' },
        { name: '田阳县蔬心特色农产品经营部', address: '广西省百色市', phone: '88383928' }
      ]
    }
  },
  components: {
  },
  computed: {
    positionItem() {
      return this.detailList[this.positionTimes % this.detailList.length]
    }
  },
  methods: {
  },
  mounted() {
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?6bd1d6ef